// extracted by mini-css-extract-plugin
export default {"sidebar":"CreateBookStore_sidebar__Rv1Qg","container":"CreateBookStore_container__WoYf0","mainContent":"CreateBookStore_mainContent__DZjz5"};